import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';
import { ResourceNotFoundError } from '@/utils/errors';

export const { ExpectedContentNotFoundError } = errorFactory(
  'ExpectedContentNotFoundError',
  ResourceNotFoundError
);

/** An error that occurs when expected content is not found. */
export type ExpectedContentNotFoundError = InstanceTypeOf<
  typeof ExpectedContentNotFoundError
>;
